import { BackendPaginatedResponse, BackendUser, Content, ReportActivityLog, ReportLog, ReportedContent } from 'common/types';
import { makeAutoObservable } from 'mobx';
export type Filters = {
    status?: string
    type?: string
  }

class ReportedContentStore {
    reportedContents: ReportedContent[] | undefined[] = []
    reportedContent: Partial<ReportedContent> & { content: Content } & { reporteeUser: BackendUser } = JSON.parse(localStorage.getItem('reportedContent')) || {}
    isLoading = false
    reportsById: ReportedContent[]
    totalCount = 0
    page = 1
    isDrawerOpen = false
    filters: Filters
    showTypeFilter = true
    showSuspendUser = false
    showBlockUser = false
    shouldDisableAllActions = false
    showCloseReportModal = false
    numberOfDays: number | undefined = undefined
    reason = ''
    showReportContentActionModal = false
    isReady = false
    isReportLogReady = false
    isReportActivityLogReady = false
    isOpen = false
    reportActivityLogs: BackendPaginatedResponse<ReportActivityLog[]> 
    reportLogs: BackendPaginatedResponse<ReportLog[]>
    reportActivityPage = 1
    reportLogPage = 1 
    

    constructor() {
        makeAutoObservable(this);
    }

    setReportedContents = (reportedContents: ReportedContent[]) => {
        this.reportedContents = reportedContents
    };

    setReportedContent = (reportedContent: Partial<ReportedContent> & { content: Content } & { reporteeUser: BackendUser }) => {
        this.reportedContent = reportedContent
        localStorage.setItem('reportedContent', JSON.stringify(reportedContent));
    }

    setIsLoading = (isLoading: boolean) => {
        this.isLoading = isLoading
    }

    setReportsById = (reportsById: ReportedContent[]) => {
        this.reportsById = reportsById
    }

    setTotalCount = (totalCount: number) => {
        this.totalCount = totalCount
    }

    setPage = (page: number) =>{
        this.page =page
    }

    setIsDrawerOpen = (isDrawerOpen: boolean) =>{
        this.isDrawerOpen = isDrawerOpen
    }

    setFilters = (filters: any) =>{
        this.filters = filters
    }

    setShowTypeFilter = (showTypeFilter: boolean) =>{
        this.showTypeFilter = showTypeFilter
    }
    handleCloseReportModal = () => {
        this.setShowSuspendUser(false)
        this.setShowBlockUser(false)
        this.setShowCloseReportModal(false)
        this.setNumberOfDays(undefined)
        this.setReason('')
      }
    setShowSuspendUser = (showSuspendUser: boolean) =>{
        this.showSuspendUser = showSuspendUser
    }
    setShowBlockUser = (showBlockUser: boolean) =>{
        this.showBlockUser = showBlockUser
    }
    setShouldDisableAllActions = (shouldDisableAllActions: boolean) =>{
        this.shouldDisableAllActions = shouldDisableAllActions
    }
    setShowCloseReportModal = (showCloseReportModal: boolean) =>{
        this.showCloseReportModal = showCloseReportModal
    }
    setNumberOfDays = (numberOfDays: number | undefined) => {
        this.numberOfDays = numberOfDays
    }
    setReason = (reason: string) =>{
        this.reason = reason
    }
    setShowReportContentActionModal = (showReportContentActionModal: boolean) => {
        this.showReportContentActionModal = showReportContentActionModal
    }
    isAssignedToMyself = (backendUser: BackendUser) => {
        const backendUserName = `${backendUser?.firstName} ${backendUser?.lastName}`
        return this.reportedContent?.assignedTo === backendUserName
    }

    setIsReady = (isReady: boolean) => {
        this.isReady = isReady
    }
    setIsReportLogReady = (isReportLogReady: boolean) => {
        this.isReportLogReady = isReportLogReady
    }
    setIsReportActivityLogReady = (isReportActivityLogReady: boolean) => {
        this.isReportActivityLogReady = isReportActivityLogReady
    }
    setIsOpen = (isOpen: boolean) => {
        this.isOpen = isOpen
    }
    setReportActivityPage = (reportActivityPage: number) => {
        this.reportActivityPage = reportActivityPage
    }
    setReportLogPage = (reportLogPage: number) => {
        this.reportLogPage = reportLogPage
    }
    setReportActivityLogs = (reportActivityLogs: BackendPaginatedResponse<ReportActivityLog[]>) => {
        this.reportActivityLogs = reportActivityLogs
    }
    setReportLogs = (reportLogs: BackendPaginatedResponse<ReportLog[]>) => {
        this.reportLogs = reportLogs
    }
}

export const ReportedContentState = new ReportedContentStore();
